import { Box, Card, Divider, Grid2, Typography } from '@mui/material';
import IsOnlineComponent from '../../../../components/IsOnlineComponent';
import OutputsList from './OutputsList';
import ButtonComponent from '../../../../components/ButtonComponent';
import AlarmCentralProblemsDialog from './AlarmCentralProblemsDialog';
import { useState } from 'react';

interface AlarmCentralResumeCardProps {
  name: string;
  isVirtual: boolean;
  isConnected: boolean;
  lastEventDate?: Date;
  isWithProblems?: boolean;
  alarmCentral: any;
}

const AlarmCentralResumeCard = ({
  name,
  isVirtual,
  isConnected,
  lastEventDate,
  isWithProblems,
  alarmCentral,
}: AlarmCentralResumeCardProps) => {
  const [isOpenProblemsDialog, setIsOpenProblemsDialog] = useState(false);

  const timeAgo = (date: Date) => {
    const seconds = (Date.now() - date.getTime()) / 1000;
    if (seconds < 60) return 'alguns segundos atrás';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60)
      return `${minutes} minuto${minutes !== 1 ? 's' : ''} atrás`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hora${hours !== 1 ? 's' : ''} atrás`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} dia${days !== 1 ? 's' : ''} atrás`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} mese${months !== 1 ? 's' : ''} atrás`;
    const years = Math.floor(days / 365);
    return `${years} ano${years !== 1 ? 's' : ''} atrás`;
  };

  return (
    <Grid2 size={{ xs: 12, xl: 4 }} sx={{ mt: 2 }} container rowSpacing={2}>
      <Grid2 size={{ xs: 12 }}>
        <Card
          sx={{ padding: 2, mb: 1, position: 'relative' }}
          style={{ border: '1px solid rgb(47, 57, 87)', height: '100%' }}
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            {isVirtual ? 'HUB' : 'Central Física'}
          </Typography>
          <Divider
            sx={{ my: 2, color: 'gray', backgroundColor: 'rgb(47, 57, 87)' }}
          />
          <Grid2 sx={{ display: 'flex', mb: 1 }} container>
            <Grid2 size={5} sx={{ fontWeight: 'bold', mr: 1 }}>
              Nome:{' '}
            </Grid2>
            <Grid2 size={5}>{name}</Grid2>
          </Grid2>
          <Grid2 sx={{ display: 'flex' }} container>
            <Grid2 size={5} sx={{ fontWeight: 'bold', mr: 1 }}>
              Conexão:{' '}
            </Grid2>
            <Grid2 size={5} sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 1,
                }}
              >
                <IsOnlineComponent
                  height={20}
                  width={20}
                  isOnline={isConnected}
                />
              </Box>
              <Typography sx={{ ml: 1, mb: 1 }}>
                {isConnected ? 'Conectado' : 'Desconectado'}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 sx={{ display: 'flex', mb: 1 }} container>
            <Grid2 size={5} sx={{ fontWeight: 'bold', mr: 1 }}>
              Último evento:{' '}
            </Grid2>
            <Grid2 size={5} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>
                {lastEventDate
                  ? timeAgo(new Date(lastEventDate))
                  : 'Sem registro'}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 sx={{ display: 'flex' }} container>
            <Grid2
              size={5}
              sx={{ fontWeight: 'bold', mr: 1, pt: isWithProblems ? 0.8 : 0 }}
            >
              Status:{' '}
            </Grid2>
            <Grid2 size={5} sx={{ display: 'flex', alignItems: 'center' }}>
              {!isWithProblems ? (
                <Typography
                  sx={{ fontWeight: 'bold' }}
                  color={!isWithProblems && 'success'}
                >
                  OK
                </Typography>
              ) : (
                <ButtonComponent
                  sx={{
                    fontWeight: 'bold',
                  }}
                  tooltipMessage={'Clique para ver'}
                  color={'warning'}
                  variant={'text'}
                  onClick={() => setIsOpenProblemsDialog(true)}
                >
                  POSSUI PROBLEMAS
                </ButtonComponent>
              )}
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>

      <AlarmCentralProblemsDialog
        isOpen={isOpenProblemsDialog}
        onClose={() => setIsOpenProblemsDialog(false)}
      />

      <Grid2 size={{ xs: 12 }}>
        <OutputsList alarmCentral={alarmCentral} />
      </Grid2>
    </Grid2>
  );
};

export default AlarmCentralResumeCard;
